<template>
  <div :class="$style.apps">
    <div v-for="app in data" :key="app.id" :class="[$style.app, {[$style.selected]: selectedApp === app.id}]" @click="appClick(app.id)">
      <div :class="$style.image" :style="{ backgroundImage: `url(${app.image})` }"></div>
      <p :class="$style.title">{{app.title}}</p>
      <div v-if="app.success" :class="$style.successCheck"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'apps',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedApp: null,
  }),
  methods: {
    init() {},
    appClick(id) {
      this.$emit('appClick', id)
      this.selectedApp = id
    },
  },
  mounted() {
    this.init()
  },
}
</script>
<style lang="scss" module src="./apps.scss"></style>
